import BMenu from './menu'

/* istanbul ignore next */
BMenu.install = function (Vue) {
  Vue.component(BMenu.name, BMenu)
}

export default BMenu
